import { Navigate } from 'react-router-dom';
import Page404 from '@/common/views/Page404';
import AccountLogsPage from './views/AccountLogs';
import AccountsPage from './views/Accounts';
import CommentLogsPage from './views/CommentLogs';
import ContentLogsPage from './views/ContentLogs';

export const adminTraceRoutes = [
  {
    path: '/admin-trace',
    name: '监测日志',
    icon: 'fund',
    children: [
      {
        index: true,
        element: <Navigate to="accounts" replace />,
      },
      {
        path: 'accounts',
        name: '监测账号',
        icon: 'profile',
        element: <AccountsPage />,
      },
      {
        path: 'account-logs',
        name: '账号日志',
        icon: 'barChart',
        element: <AccountLogsPage />,
      },
      {
        path: 'content-logs',
        name: '内容日志',
        icon: 'fileText',
        element: <ContentLogsPage />,
      },
      {
        path: 'comment-logs',
        name: '评论日志',
        icon: 'message',
        element: <CommentLogsPage />,
      },
      {
        path: '*',
        element: <Page404 />,
      },
    ],
  },
];
